<template>
  <div>
    <el-card>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-cascader
            clearable
            v-model="searchForm.scheduleInfoCampusId"
            :show-all-levels="false"
            :props="campusTreeProps"
            placeholder="请选择所属校区"
            :options="campusList"
            collapse-tags
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.classroomName"
            placeholder="教室名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchForm.beginDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            :clearable="false"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pageList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top:20px">
      <div class="flex" style="margin-bottom:20px">
        <div class="flex ">
          <div>上午：</div>
          <div class="bgPink exampleDiv"></div>
        </div>
        <div class="flex">
          <div>下午：</div>
          <div class="bgGreen exampleDiv"></div>
        </div>
        <div class="flex">
          <div>晚上：</div>
          <div class="bgGrey exampleDiv"></div>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          fixed
          prop="campusName"
          label="所属校区"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          fixed
          prop="name"
          label="班级"
          show-overflow-tooltip
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          align="center"
          v-for="(item, index) in dayList"
          :key="index"
          :label="item"
          width="100"
        >
          <template slot-scope="scope">
            <el-tooltip
              :enterable="false"
              class="item"
              effect="light"
              placement="right"
              v-if="scope.row.data[index].data.length != 0"
            >
              <div slot="content">
                {{ scope.row.data[index].data[0].classroom.name }}
                <div v-for="item in scope.row.data[index].data" :key="item.id">
                  <div class="scheduleTime">
                    {{ scope.row.data[index].date
                    }}{{ item.schedulePeriod.beginTime }}
                  </div>
                  <div class="scheduleInfo">
                    地点：{{ item.classInfo.name }}
                  </div>
                  <div class="scheduleInfo">老师：{{ item.teacher.name }}</div>
                </div>
              </div>
              <div>
                <div
                  class="bgPink tableExampleDiv"
                  :class="{ bgBai: !scope.row.data[index].schedule[0] }"
                ></div>
                <div
                  class="bgGreen tableExampleDiv"
                  :class="{ bgBai: !scope.row.data[index].schedule[1] }"
                ></div>
                <div
                  class="bgGrey tableExampleDiv"
                  :class="{ bgBai: !scope.row.data[index].schedule[2] }"
                ></div>
              </div>
            </el-tooltip>
            <div v-else>
              <div class="bgBai tableExampleDiv"></div>
              <div class="bgBai tableExampleDiv"></div>
              <div class="bgBai tableExampleDiv"></div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      searchForm: {
        scheduleInfoCampusId: [],
        classroomName: "",
        beginDate: [],
        endDate: ""
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusList: [],
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      dayList: [],
      scheduleDetail: [],
      dialogVisible: false
    };
  },
  methods: {
    pageList() {
      this.loading = true;
      this.dayList = [];
      this.getDayList(this.searchForm.beginDate);
      let obj = Object.assign({}, this.searchForm);
      obj.beginDate = this.searchForm.beginDate[0];
      obj.endDate = this.searchForm.beginDate[1];
      obj.scheduleInfoCampusId = this.searchForm.scheduleInfoCampusId[
        this.searchForm.scheduleInfoCampusId.length - 1
      ];
      this.api.classroom.classroomCalendarInfo(obj).then(res => {
        let arr = res.data || [];
        arr.forEach(item => {
          item.data.forEach(_item => {
            let schedule = [false, false, false];
            _item.data.forEach(Item => {
              Item = Item || {};
              if (Item.schedulePeriod) {
                let beginTime = Item.schedulePeriod.beginTime;
                if (beginTime == "18:30") {
                  schedule[2] = true;
                } else if (beginTime == "09:00") {
                  schedule[0] = true;
                } else if (beginTime == "13:00") {
                  schedule[1] = true;
                }
              }
            });
            _item.schedule = schedule;
          });
        });
        this.tableData = res.data || [];
        this.loading = false;
      });
    },
    //获取日期数组
    getDayList(val) {
      let start = val[0];
      let end = val[1];
      if (start != end) {
        this.dayList.push(this.$moment(start).format("MM月DD日"));
        start = this.$moment(start)
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.getDayList([start, end]);
      } else if (start == end) {
        this.dayList.push(this.$moment(end).format("MM月DD日"));
      }
    },
    //获取课程树
    getCampusList() {
      this.api.campus.getPermissionCampusTree({ parentId: 1 }).then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {
              if (items.children.length != 0) {
                for (let itemss of items.children) {
                  if (itemss.children.length != 0) {
                    delete itemss.children;
                  } else {
                    delete itemss.children;
                  }
                }
              } else {
                delete items.children;
              }
            }
          } else {
            delete item.children;
          }
        }
        this.campusList = result.data;
      });
    }
  },
  mounted() {
    this.getCampusList();
    const end = this.$moment(new Date()).format("YYYY-MM-DD");
    const start = this.$moment(end)
      .subtract(30, "days")
      .format("YYYY-MM-DD");
    this.searchForm.beginDate = [start, end];
    this.pageList();
  }
};
</script>
<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
}
.exampleDiv {
  width: 60px;
  height: 20px;
  margin-right: 30px;
}
.tableExampleDiv {
  width: 100px;
  height: 20px;
}
.bgPink {
  background: rgb(240, 181, 181);
}
.bgGreen {
  background: rgb(207, 230, 181);
}
.bgGrey {
  background: rgb(205, 212, 218);
}
.bgBai {
  background: #fff !important;
}
.el-table {
  /deep/ td {
    padding: 0px !important;
    /deep/ .cell {
      padding: 0px !important;
    }
  }
}
.scheduleTime {
  margin-top: 20px;
  color: royalblue;
  margin-bottom: 10px;
}
.scheduleInfo {
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/classroom/classroomSchedule.vue